module.exports = __webpack_public_path__ + "img/herb-rosemary-350x184.5dbee331.jpg";